import React from 'react';
// Components
import CommercialInfoContainer from './CommercialInfoContainer';
import ReviewsShortSection from '../reviews/ReviewsShortSection';
import MainCta from '../cta/MainCta';
import CommercialsFaqSection from '../faq/CommercialsFaqSection';


function CommercialsPageMainContainer() {
  return (
    <main role='main' className='grid gap-y-8 lg:gap-y-12 w-full h-full'>
      <CommercialInfoContainer />
      <ReviewsShortSection />
      <MainCta />
      <CommercialsFaqSection />
    </main>
  );
}

export default CommercialsPageMainContainer;
